import { JoomlaApi, WordpressApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const wordPressApi = WordpressApi({}, '/api', axiosInstance);
export const joomlaApi = JoomlaApi({}, '/api', axiosInstance);
